import { useCallback, useMemo } from "react";
import { ensureExhaustive, typedKeys } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { FilterSpecificationProps } from "./FilterSpecification";
import type { Specification } from "~core-cars/types";

export const useFilterSpecification = ({
  selectedValues,
  onChange,
}: FilterSpecificationProps) => {
  const { t } = useI18nContext();

  const getSpecificationLabel = useCallback(
    (specification: keyof Specification) => {
      switch (specification) {
        case "unlimitedMileage":
          return t("core-cars.filters.specifications.options.unlimitedMileage");
        case "automaticTransmission":
          return t(
            "core-cars.filters.specifications.options.automaticTransmission"
          );
        case "airCondition":
          return t("core-cars.filters.specifications.options.airConditioning");
        default:
          ensureExhaustive(specification);
      }
    },
    [t]
  );

  const items = useMemo(() => {
    return typedKeys(selectedValues).map((o) => ({
      label: getSpecificationLabel(o),
      value: o,
    }));
  }, [getSpecificationLabel, selectedValues]);

  return useMemo(
    () => ({
      selectedValues,
      items,
      onChange,
    }),
    [selectedValues, items, onChange]
  );
};
